import ButtonIcon from "#common/buttons/ButtonIcon"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { TableMain } from "#core/components/table-main/TableMain"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import { Button, Stack } from "@mui/material"
import { Fragment, useMemo, useState } from "react"
import PerceptionDelete from "../components/perception/PerceptionDelete"
import PerceptionEdit from "../components/perception/PerceptionEdit"
import PerceptionFormDialog from "../components/perception/PerceptionForm"
import { UseDialogBajaContext } from "../DialogDetailBaja/components/DialogBajaContext"
import { earningsGet } from "../services/api"

export default function Perceptions() {
	const [reload, setReload] = useState(false)
	const refresh = () => {
		setReload(!reload)
	}
	const [openForm, setOpenForm] = useState(false)
	const [edit, setEdit] = useState(false)
	const [deleteItem, setDeleteItem] = useState(false)
	const { baja } = UseDialogBajaContext()
	const params = useMemo(() => ({ id: baja.id }), [baja.id])
	const { data, error, loading } = useApi(earningsGet, {
		params,
		autoFetch: true,
		reload,
	})

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />
	const { earnings = [] } = data || {}

	const items = [
		{ name: "name", label: "Nombre" },
		{ name: "amount", label: "Monto" },
		{ name: "concept_type_name", label: "Tipo" },
		{
			name: "",
			label: "",
			options: {
				customBodyRender: (value, data) => {
					console.log("🚀 ~ PerceptionsItems ~ data:", data)
					return (
						<Stack direction="row" spacing={1}>
							<ButtonIcon
								title="Editar percepción"
								onClick={() => setEdit(data)}
								icon={<EditIcon />}
							/>
							<ButtonIcon
								title="Eliminar percepción"
								onClick={() => setDeleteItem(data)}
								icon={<DeleteIcon />}
							/>
						</Stack>
					)
				},
			},
		},
	]
	const options = {}
	// if (is_enabled)
	options.customToolbar = () => (
		<Button variant="contained" color="primary" onClick={() => setOpenForm(true)}>
			Agregar
		</Button>
	)

	return (
		<Fragment>
			<TableMain data={earnings} items={items} options={options} />
			<PerceptionEdit
				open={!!edit}
				setOpen={setEdit}
				refresh={refresh}
				perception={edit}
			/>
			<PerceptionDelete
				open={!!deleteItem}
				setOpen={setDeleteItem}
				refresh={refresh}
				perception={deleteItem}
			/>
			<PerceptionFormDialog open={openForm} setOpen={setOpenForm} refresh={refresh} />
		</Fragment>
	)
}
